export default __webpack_public_path__ + "assets/images/50d1841cbb0c87225d2d6f2e02da9b35.png";